import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AjaxGenerateToken } from "../components/AsyncAjaxServiceV2";

let Token = [];
const VagaroAPIEnum = {
    GenerateToken: "token/generatetoken"
};
export const TokenGenerate = createAsyncThunk(
    'PostGenerateToken',
    async (Request, thunkApi) => {

        Token.access_token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IkQ3RTVCRkQ5QTg0REQ4QTgxQTU0QTY0NzlCOEQyNDRGREM0MDYxNTRSUzI1NiIsInR5cCI6ImF0K2p3dCIsIng1dCI6IjEtV18yYWhOMktnYVZLWkhtNDBrVDl4QVlWUSJ9.eyJuYmYiOjE3NDMxMzY5NDUsImV4cCI6MTc0MzE0MDU0NSwiaXNzIjoiaHR0cHM6Ly9hcy1kZXYtMDQtaWRzLmF6dXJld2Vic2l0ZXMubmV0IiwiY2xpZW50X2lkIjoiYTRlNTU0ODUtYmY0Zi00ZmU4LTk4ZjEtZjU1NTc0YjlhYmJkIiwiaWF0IjoxNzQzMTM2OTQ1LCJzY29wZSI6WyJ2YWdhcm9fdjJfYXBpIl19.RQgokH6oPgCNED2YjK8jzRu8SM96AEncUfdIsyPu4uaBnDO3DxqLxC4S8mfLlNovHEA7W4GNAxuj3zn4j54UE20e0AM6rOlRqR-KsAAAv6oMeMhTlaIOp5A8wSZ8GxDRCId71aMrUKze-mFZIVSE4mzavxKbpdBtuQuzwPcjdv4izqxpUPr5U4DsQYeDYseNBgq_pXV2efyJAS3TVDJU1r99ViOd-8fxj37VwzqXVErkr83XG7QZKP3Y9VnhJjRw6-2kzHbT0InMXcfxJysmNMDtbI6NM9WQQOsMkcSTlGxJlbdD-pC3G1L7hbzGRCb7vhuUtKGOoZHlT0MSo3BImQ";
        Token.expires_in = "3600";

        //await AjaxGenerateToken(
        //    VagaroAPIEnum.GenerateToken,
        //    Request,
        //    function onSuccess(data) {
        //        if (data != null && data.data != null) {
        //            Token = data.data;
        //        }
        //        else {
        //            return thunkApi.rejectWithValue([]);
        //        }
        //    },
        //    function OnError() {
        //        return thunkApi.rejectWithValue([]);
        //    }
        //);
        return thunkApi.fulfillWithValue(Token);
    }
)

export const TokenSlice = createSlice({
    name: 'Token',
    initialState: {
        access_token: "",
        expires_in: "",
        token_type: "",
        scope: "",
        generateTime: new Date().setMinutes(new Date().getMinutes() - 45)
    },
    extraReducers: {
        [TokenGenerate.fulfilled]: (state, action) => {
            if (typeof action.payload !== undefined && action.payload !== null) {
                state.access_token = action.payload.access_token;
                state.expires_in = action.payload.expires_in;
                state.token_type = action.payload.token_type;
                state.scope = action.payload.scope;
                state.generate_time = new Date().setMinutes(new Date().getMinutes() + 45);
            }
        }
    }
})
export default TokenSlice.reducer;
